import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';

// Actions
import { updateQueryString, deleteQueryString } from 'services/router/actions';

// Selectors
import { selectApplicationRateOptions } from 'services/equipmentSets/selectors';

// Workspaces
import { makeSelectQueryStringNumberValue } from 'workspaces/react-router-selectors';

interface Props {
    clearable?: boolean;
    singleFilter?: boolean;
}

const ApplicationRateDropdown = ({
    clearable,
    singleFilter
}: Props): React.ReactElement => {
    const dispatch = useDispatch();

    const applicationRate: number = useSelector(
        makeSelectQueryStringNumberValue('applicationRate')
    );
    const applicationRateOptions = useSelector(selectApplicationRateOptions);

    const handleChange = (event: any, data: any) => {
        if (singleFilter) dispatch(deleteQueryString());
        dispatch(updateQueryString({ applicationRate: data.value }));
    };

    return (
        <Dropdown
            placeholder="All Application Rates"
            search
            selection
            value={applicationRate}
            clearable={clearable}
            selectOnBlur={false}
            options={applicationRateOptions}
            onChange={handleChange}
            lazyLoad
            closeOnChange
            fluid
        />
    );
};

ApplicationRateDropdown.defaultProps = {
    clearable: true,
    singleFilter: false
};

export default ApplicationRateDropdown;
